import './rubriche.scss';

/**
 * version    1.0
 * class      <type> (Rubriche)
 * classdesc
 */
export class Rubriche {}
